export default __webpack_public_path__ + "static/media/step1.e5912969.png";